import { AfterViewInit, Directive } from '@angular/core';
import { IWizPop } from '../../interfaces/iwiz-pop';
import { WizPopUp } from './wiz-popup';
import { WizMathUtils } from '@wizeoo/akm-core-lib';

// Base class for pops
@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class WizBasePopUp implements IWizPop, AfterViewInit {
  // flag d'existence pour déclencher onShow(): true : vue construite
  public achieved: boolean = false;
  // demande prématurée sur onShow()
  public earlyOnShow: boolean = false;

  // technical key
  public code: string = '';
  // label (translation base key)
  public title = '';

  // UUID feed by constructor
  public uuid: string;

  public datas: any; // datas from owner
  public parameters: WizPopUp; // accesseur sur l'objet de configuration source

  public static requestWidth: string = null; // pour override de prise de taille sur construction. Sera accessible depuis la factory

  // callback from owner
  public callback?: Function;

  constructor() {
    this.uuid = WizMathUtils.createUUID();
  }

  ngAfterViewInit(): void {
    this.achieved = true;
    if (this.earlyOnShow) {
      this.earlyOnShow = false;
      setTimeout(() => {
        this.onShow();
      }, 0);
    }
  }

  /**
   * Pour appel EXTERNE UNIQUEMENT
   * permet d'éviter le nullPointer sur alimentation des données de la pop AVANT construction
   */
  public onShow() {
    if (!this.achieved) {
      this.earlyOnShow = true;
      return;
    }
    this.show();
  }

  public show() {}

  public onHide() {}

  public hide(pResult?: any) {
    this.parameters.hide(pResult);
  }
}
